var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0212 2.56066C21.607 1.97487 21.607 1.02513 21.0212 0.43934C20.4355 -0.146447 19.4857 -0.146447 18.8999 0.43934L10.7304 8.60886L2.56088 0.43934C1.9751 -0.146447 1.02535 -0.146447 0.439562 0.43934C-0.146225 1.02513 -0.146225 1.97487 0.439562 2.56066L8.60908 10.7302L0.43934 18.8999C-0.146447 19.4857 -0.146447 20.4355 0.43934 21.0212C1.02513 21.607 1.97487 21.607 2.56066 21.0212L10.7304 12.8515L18.9001 21.0212C19.4859 21.607 20.4357 21.607 21.0215 21.0212C21.6073 20.4355 21.6073 19.4857 21.0215 18.8999L12.8517 10.7302L21.0212 2.56066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhiteClose);
export default __webpack_public_path__ + "static/media/ic-whiteClose.40551f1a83f0f764b0e869c9975c5900.svg";
export { ForwardRef as ReactComponent };